import { render } from "./OperationPage.vue?vue&type=template&id=f5706192&ts=true"
import script from "./OperationPage.vue?vue&type=script&lang=ts"
export * from "./OperationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__